module.exports = {
  temList: "",
};
